<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-01-10 19:22:01
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-01 14:31:30
-->
<template>
	<div>
		<el-button type="primary" :disabled="!row.hasSku" plain @click="showSkuDrawer(row.productId)" size="mini">选择规格</el-button>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	inject: ['showSkuDrawer'],
	data() {
		return {};
	},
};
</script>
<style lang="less" scoped>
::v-deep .el-button--primary.is-disabled:hover {
	background-color: @color-white !important;
	color: #bdd5ff !important;
}
::v-deep .el-button--primary.is-disabled {
	color: #bdd5ff !important;
}
</style>
